// @mui material components
import {
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  TextField,
  Box,
  Grid,
} from "@mui/material";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import StudentCard from "components/StudentCardforAttd";
import AttendanceCard from "components/AttendanceCard";

// Ajce Hostel App React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useRef, useState } from "react";
import MDSnackbar from "components/MDSnackbar";
import { markAttendance } from "framework/students/attendance";
import { getAttendanceByDate } from "framework/students/attendance";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useMaterialUIController } from "context";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { InputLabel, MenuItem, Select } from "@mui/material";
import { format } from "date-fns";

function Stdatt() {
  const [uicontrol] = useMaterialUIController();
  const [studentData, setStudentData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [attendanceData, setAttendanceData] = useState([]);
  const [isFetchingAttendance, setIsFetchingAttendance] = useState(false);
  const [isCheckingAttendance, setisCheckingAttendance] = useState(false);
  const [err, setErr] = useState(null);
  const [snackbar, setSnackbar] = useState({
    desc: "",
    type: "success",
    icon: "check",
  });
  const [reportType, setReportType] = useState("o");
  const studentCardRef = useRef();
  const pdfRef = useRef();

  async function getAttendanceForSelectedDate() {
    if (!selectedDate) {
      console.warn("Please select a date.");
      return;
    }

    const date = new Date(selectedDate);

    try {
      setIsFetchingAttendance(true);
      const attendanceData = await getAttendanceByDate(date);
      setAttendanceData(attendanceData);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    } finally {
      setIsFetchingAttendance(false);
    }
  }

  async function attendanceToggle() {
    const isMarked = !studentData.isMarked;
    setStudentData((prev) => ({
      ...prev,
      isMarked: !prev.isMarked,
    }));
    try {
      setisCheckingAttendance(true);
      await markAttendance(studentData);
      setSnackbar({
        desc: `Student is ${isMarked ? "Present" : "Absent"}`,
        type: "success",
        icon: "check",
      });
      setStudentData(null);
    } catch (err) {
      console.error(err);
      setStudentData((prev) => ({ ...prev, isMarked: !prev.isMarked }));
      setSnackbar({
        desc: `Couldn't update the attendance, please try again.`,
        type: "error",
        icon: "error",
      });
    } finally {
      setisCheckingAttendance(false);
    }
  }

  function closeSanckbar() {
    setSnackbar((prev) => ({ ...prev, desc: "" }));
  }

  // Function to generate the PDF report
  const generatePdfReport = () => {
    // Create a new instance of jsPDF
    const doc = new jsPDF();

    doc.setFontSize(36);
    doc.text("Attendance Report", 55, 150);
    doc.setFontSize(16);
    doc.addPage();

    // Generate the overall report
    if (reportType === "o" && attendanceData.overall) {
      doc.text("Overall Report", 10, 10);

      // Generate the table for the overall report
      const overallTableData = attendanceData.overall.map((item, index) => [
        index + 1,
        item.admissionNo,
        item.branch,
        item.sem,
        // Format the "item.time" as "MM-dd-yyyy"
        format(item.time.toDate(), 'MM-dd-yyyy')
      ]);

      doc.autoTable({
        startY: 20,
        head: [["#", "Admission No", "Branch", "Semester", "Date"]],
        body: overallTableData,
      });
    }

    // Generate the branchwise report
    if (reportType === "b" && attendanceData.byBranch) {
      // Generate tables for each branch
      Object.keys(attendanceData.byBranch).forEach((branch) => {
        doc.text(`Branch: ${branch}`, 10, 10);

        const branchTableData = attendanceData.byBranch[branch].map((item, index) => [
          index + 1,
          item.admissionNo,
          item.branch,
          // Format the "item.time" as "MM-dd-yyyy"
          format(item.time.toDate(), 'MM-dd-yyyy'),
        ]);

        doc.autoTable({
          startY: 20,
          head: [["#", "Admission No", "Semester", "Date"]],
          body: branchTableData,
        });

        doc.addPage();
      });
    }

    // Generate the semwise report
    if (reportType === "s" && attendanceData.bySem) {
      // Generate tables for each semester
      Object.keys(attendanceData.bySem).forEach((sem) => {
        doc.text(`Semester: ${sem}`, 10, 10);

        const semTableData = attendanceData.bySem[sem].map((item, index) => [
          index + 1,
          item.admissionNo,
          item.sem,
          // Format the "item.time" as "MM-dd-yyyy"
          format(item.time.toDate(), 'MM-dd-yyyy'),
        ]);

        doc.autoTable({
          startY: 20,
          head: [["#", "Admission No", "Branch", "Date"]],
          body: semTableData,
        });

        doc.addPage();
      });
    }

    // Save the PDF or open it in a new tab
    doc.save("AttendanceReport.pdf");
  };

  // Handler for the "Generate PDF" button click
  const handleGeneratePdfClick = () => {
    if (attendanceData && reportType) {
      generatePdfReport();
    }
  };

  console.log(attendanceData);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox p={5}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100%" // Ensure the container takes the full height of the parent
        >
          <Grid item xs={12} md={12} lg={12}>
            <MDTypography variant="h2">Attendance Report</MDTypography>
          </Grid>
          <CardContent>
            <Grid py={3} container spacing={1}>
              <Grid item xs={12} md={12} lg={12} style={{ paddingBottom: "16px" }}>
                <InputLabel id="report-type-select-label" style={{marginBottom: "1em"}}>Date</InputLabel>
                <MDInput
                  required
                  fullWidth
                  type="date"
                  // label="Date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                />
              </Grid>
              {"  "}
              <Grid item xs={12} md={12} lg={12}>
                <InputLabel id="report-type-select-label" style={{marginBottom: "1em"}}>Report Type</InputLabel>
                <Select
                  labelId="report-type-select-label"
                  id="select-report-type"
                  label="report-type"
                  value={reportType}
                  onChange={(e) => {
                    setReportType(e.target.value);
                  }}
                  fullWidth
                  style={{ height: "40px" }}
                >
                  <MenuItem value="o">Overall</MenuItem>
                  <MenuItem value="b">Branch Wise</MenuItem>
                  <MenuItem value="s">Semester Wise</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDButton
                  type="submit"
                  fullWidth
                  variant="gradient"
                  color={uicontrol.sidenavColor}
                  sx={{ height: "40px" }}
                  onClick={getAttendanceForSelectedDate}
                  disabled={isFetchingAttendance}
                  style={{marginTop: "1em"}}
                >
                  Get Report
                </MDButton>
              </Grid>
            </Grid>
          </CardContent>
          {/* <TextField
            label="Enter Date (YYYY-MM-DD)"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          /> */}

          <Grid container spacing={2}>
            {attendanceData.overall && reportType == "o" && (
              <Grid item xs={12} md={6} lg={4}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="success"
                    icon="done"
                    title="Overall"
                    count={attendanceData.overall.length}
                    percentage={{
                      color: "success",
                      amount: "",
                      label: "",
                    }}
                  />
                </MDBox>
              </Grid>
            )}

            {attendanceData.bySem &&
              reportType == "s" &&
              Object.keys(attendanceData.bySem).map((sem) => (
                <Grid item xs={12} md={6} lg={4} key={`sem-${sem}`}>
                  <MDBox mb={1.5}>
                    <ComplexStatisticsCard
                      color="success"
                      icon="done"
                      title={`Semester ${sem}`}
                      count={attendanceData.bySem[sem].length}
                      percentage={{
                        color: "success",
                        amount: "",
                        label: "",
                      }}
                    />
                  </MDBox>
                </Grid>
              ))}

            {attendanceData.byBranch &&
              reportType == "b" &&
              Object.keys(attendanceData.byBranch).map((branch) => (
                <Grid item xs={12} md={6} lg={4} key={`branch-${branch}`}>
                  <MDBox mb={1.5}>
                    <ComplexStatisticsCard
                      color="success"
                      icon="done"
                      title={`Branch ${branch}`}
                      count={attendanceData.byBranch[branch].length}
                      percentage={{
                        color: "success",
                        amount: "",
                        label: "",
                      }}
                    />
                  </MDBox>
                </Grid>
              ))}
          </Grid>
          {attendanceData.overall &&
            <MDButton
                type="submit"
                fullWidth
                variant="gradient"
                color={uicontrol.sidenavColor}
                sx={{ height: "40px" }}
                onClick={handleGeneratePdfClick}
                disabled={!((attendanceData?.overall?.length > 0 && reportType === "o") || (Object.keys(attendanceData?.byBranch).length > 0 && reportType === "b") || ((Object.keys(attendanceData?.bySem).length > 0 && reportType === "s")))}
            >
                Generate PDF
            </MDButton>
          }
        </Box>

        <AttendanceCard
          setStudentData={setStudentData}
          setSnackbar={setSnackbar}
          studentCardRef={studentCardRef}
          setErr={setErr}
        />
        {studentData && (
          <MDBox ref={studentCardRef}>
            <StudentCard
              {...studentData}
              attendanceToggle={attendanceToggle}
              isCheckingAttendance={isCheckingAttendance}
              err={err}
            />
          </MDBox>
        )}
        <MDSnackbar
          color={snackbar.type}
          icon={snackbar.icon}
          title="AJCE Hostel Management"
          dateTime=""
          content={snackbar.desc}
          open={!!snackbar.desc}
          onClose={closeSanckbar}
          close={closeSanckbar}
          bgWhite
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Stdatt;
